import React, { CSSProperties } from 'react';
import { eventObject, subEventObject } from '../../../types/types';
import { IoMdArrowDropright, IoMdArrowDropdown } from 'react-icons/io'
import { useState } from 'react';
import { TableData } from '../../../components/utils/TableData';
import { customKeySubEventStats } from '../../../utils/functions';

interface EventRowProps {
  name: string
  id: string
  subEvents: subEventObject[]
  headerKeys: string[]
  event: eventObject
  open: (eventId: string, subEventId?: string) => void
}

interface SubEventProps {
  events: subEventObject[]
  show: boolean
}

interface StylesDictionary {
  [Key: string]: CSSProperties
}

interface FirstParentDataProps {
  name: string
  styles: string
  toggleChildsOnClick: () => void
  show: boolean
  iconStyles: StylesDictionary
  hideArrowIcon: boolean
}

export const EventTableRow: React.FC<EventRowProps> = ({ event, headerKeys, name, id, open, subEvents }) => {

  const [showSubEvents, setShow] = useState(false)
  const styles = 'border px-8 py-4 h-24 w-1/6 cursor-pointer truncate'
  const rowStyles = 'hover:text-blue-400 flex flex-col flex-nowrap md:table-row mb-2 md:mb-0'
  const subItem = 'bg-blue-100 border-white'
  const iconStyles = { marginLeft: '-20px', marginTop: '3px', position: 'absolute' } as StylesDictionary
  const customKeys = {
    registered: customKeySubEventStats(event, 'registered'),
    que: customKeySubEventStats(event, 'que'),
    show: customKeySubEventStats(event, 'show'),
    cancelled: customKeySubEventStats(event, 'cancelled')
  }
  const subEventConvertedKeys = {
    eventId: 'subEventId',
    eventName: 'subEventName',
    eventStartDateTime: 'subEventStartTime',
    eventEndDateTime: 'subEventEndTime',
    eventState: 'subEventState'
  }


  const toggleSubEvents = () => {
    setShow(prevShow => !prevShow);
  }


  const FirstParentData = ({ styles, toggleChildsOnClick, name, show, iconStyles, hideArrowIcon }: FirstParentDataProps) => {
    const arrowIcon = hideArrowIcon ? null : show ? <IoMdArrowDropdown style={iconStyles} /> : <IoMdArrowDropright style={iconStyles} />
    return (
      <td
        className={styles}
        onClick={hideArrowIcon ? null : toggleChildsOnClick}>
        {arrowIcon}
        {name}
      </td>
    )
  }

  //TODO: Tähän komponenttiin lisätään "käännösobjekti", jolla
  //voi muuttaa subeventobjectin avaimai eventobjectin vastaaviksi. 
  //Jos vastaava avain löytyy, rendataan valuena se
  //jos ei, niin rendataan sitten eventiltä peritty arvo 
  const SubEvents = ({ events, show }: SubEventProps) =>
    show ?
      <>
        {events.map(subEvent =>
          <tr className={rowStyles} key={subEvent.subEventId}>
            {headerKeys.map(key => {
              const value = subEventConvertedKeys[key] ? subEvent[subEventConvertedKeys[key]] : customKeys[key] ? customKeys[key] : event[key]
              return (
                <TableData
                  key={key}
                  value={value}
                  open={open}
                  id={id}
                  additionalId={subEvent.subEventId}
                  styles={`${styles} ${subItem}`} />)
            })}
          </tr>
        )}
      </>
      : null


  return (
    <>
      <tr className={rowStyles}>
        {
          headerKeys.map((key, i) => {
            const value = event[key] ? event[key] : customKeys[key]
            return (
              i === 0 ?
                <FirstParentData
                  key={i}
                  styles={`${styles} relative`}
                  toggleChildsOnClick={toggleSubEvents}
                  name={value}
                  show={showSubEvents}
                  hideArrowIcon={!subEvents.length}
                  iconStyles={iconStyles} />
                :
                <TableData
                  key={i}
                  value={value}
                  open={open}
                  id={id} />)
          })
        }
      </tr>
      <SubEvents events={subEvents} show={showSubEvents} />
    </>
  );
}

export default EventTableRow;
